import { useCallback, useMemo, useRef } from 'react';
import { sampleProjects } from '../lib/portfolio';

export const useFeaturedProjects = (projects, count = 12) => {
  const scrollerRef = useRef(null);
  const featured = useMemo(() => sampleProjects(projects, count), [projects, count]);
  const scrollBy = useCallback((direction) => {
    scrollerRef.current?.scrollBy({ left: direction * 540, behavior: 'smooth' });
  }, []);
  return { scrollerRef, featured, scrollBy };
};